<template>
    <ul class="list-unstyled">
        <li>
            <strong>{{ $t("message.forWindows") }}</strong>
            <hr />
        </li>
        <li>
            <b-badge>CTRL</b-badge>
            +
            <b-badge>M</b-badge>
            {{ $t("message.openPrivateChat") }}
        </li>
        <li>
            <b-badge>CTRL</b-badge>
            +
            <b-badge>↑</b-badge>
            {{ $t("message.closeActiveChat") }}
        </li>
        <li>
            <b-badge>CTRL</b-badge>
            +
            <b-badge>→</b-badge>
            {{ $t("message.nextChatFromActive") }}
        </li>
        <li>
            <b-badge>CTRL</b-badge>
            +
            <b-badge>←</b-badge>
            {{ $t("message.previousChatFromActive") }}
        </li>
        <li>
            <b-badge>CTRL</b-badge>
            +
            <b-badge>↓</b-badge>
            {{ $t("message.hideActiveChat") }}
        </li>
        <li>
            <b-badge>ESC</b-badge>
            {{ $t("message.escKey") }}
        </li>
        <li>
            <b-badge>F1</b-badge>
            {{ $t("message.focusInput") }}
        </li>
        <li>
            <b-badge>F2</b-badge>
            {{ $t("message.firsthiddenChat") }}
        </li>
        <li>
            <b-badge>F3</b-badge>
            {{ $t("message.firstChatWaiting") }}
        </li>
        <li>
            <b-badge>F4</b-badge>
            {{ $t("message.previousOpenedChat") }}
        </li>
        <li style="margin-top: 10px">
            <strong>{{ $t("message.forMac") }}</strong>
            <hr />
        </li>
        <li>
            <b-badge>CTRL</b-badge>
            +
            <b-badge>M</b-badge>
            {{ $t("message.openPrivateChat") }}
        </li>
        <li>
            <b-badge>CTRL</b-badge>
            +
            <b-badge>↑</b-badge>
            {{ $t("message.closeActiveChat") }}
        </li>
        <li>
            <b-badge>OPT</b-badge>
            +
            <b-badge>→</b-badge>
            {{ $t("message.nextChatFromActive") }}
        </li>
        <li>
            <b-badge>OPT</b-badge>
            +
            <b-badge>←</b-badge>
            {{ $t("message.previousChatFromActive") }}
        </li>
        <li>
            <b-badge>OPT</b-badge>
            +
            <b-badge>↓</b-badge>
            {{ $t("message.hideActiveChat") }}
        </li>
        <li>
            <b-badge>ESC</b-badge>
            {{ $t("message.escKey") }}
        </li>
        <li>
            <b-badge>F1</b-badge>
            {{ $t("message.focusInput") }}
        </li>
        <li>
            <b-badge>F2</b-badge>
            {{ $t("message.firsthiddenChat") }}
        </li>
        <li>
            <b-badge>F3</b-badge>
            {{ $t("message.firstChatWaiting") }}
        </li>
        <li>
            <b-badge>F4</b-badge>
            {{ $t("message.previousOpenedChat") }}
        </li>
    </ul>
</template>

<script>
export default {
    name: "KeyboardShortcuts",
};
</script>

<style scoped></style>
